import api from "./api";

function adminUrl(path) {
    const baseURL = api.defaults.baseURL || window.location.origin;
    return new URL(`../admin/error-monitoring/${String(path || "").replace(/^\/+/, "")}`, baseURL).toString();
}

function dataOf(response) {
    return response?.data?.data ?? response?.data ?? null;
}

export async function fetchErrorIncidents(params = {}) {
    return dataOf(await api.get(adminUrl("incidents"), {params}));
}

export async function fetchErrorIncident(documentId) {
    return dataOf(await api.get(adminUrl(`incidents/${documentId}`)));
}

export async function updateErrorIncidentStatus(documentId, status) {
    return dataOf(await api.patch(adminUrl(`incidents/${documentId}/status`), {status}));
}

export async function overrideErrorIncidentSeverity(documentId, severity, reason) {
    return dataOf(await api.patch(adminUrl(`incidents/${documentId}/severity`), {severity, reason}));
}

export async function resolveErrorIncident(documentId, payload) {
    return dataOf(await api.post(adminUrl(`incidents/${documentId}/resolve`), payload));
}

